module.exports = __webpack_public_path__ + "static/img/grid-img@t.0fd53c3.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/project-detail/lgchem/grid-img@t.png
// module id = J77i
// module chunks = 0